import {
  Box,
  Breadcrumbs,
  Button,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Question } from "../Utils";
import { ObjectValues } from "../../login";
import { NavigateNextOutlined } from "@mui/icons-material";
import MockMangementsContainer from "../../MockMangements";
import apiRequest from "../../../request/apiRequest/apiRequest";
import { allApis } from "../../../request/config";
import DistributeQuestionsDialog from "../DistributeQuestionsDialog";
import { updateRefetch } from "../../../store/slices/userManagement";
import { useAppDispatch } from "../../../hooks/storeHooks";
import globalColors from "../../../globalColors";
import { iconText } from "../../../Components/CustomTexts";
import CustomIconButton from "../../../Components/CustomIconButton";
import SvgPreview from "../../../Components/SvgPreview";
import { cross } from "../../../assets/svgs";
import { rowSB } from "../../../GlobalStyles";
import useCopiedData from "../../../store/slices/constants/staticContents/useCopiedData";
import { getServerEnvironment } from "../../../store/slices/constants/staticContents";
import useLastMockMoved from "../../../store/slices/constants/staticContents/useLastMockMoved";
export interface ImportQuestionsFromMockProps {
  dialogRef: React.MutableRefObject<{ onSubmitForm?: () => void }>;
  onSubmit: (questions: Question[]) => void;
  onClose: () => void;
  topic?: ObjectValues;
  hierarchy?: any;
  setLoader?:any;
}
function ImportQuestionsFromMock({
  hierarchy,
  onClose,
  onSubmit,setLoader
}: ImportQuestionsFromMockProps) {
  const dispatch = useAppDispatch();
  const {setlastMock}=useLastMockMoved()
  const { clearCopiedData,copiedData } = useCopiedData();
  const [pasteDialogOpen, setPasteDialogOpen] = useState(false);
  return (
    <Stack
      flex={"8"}
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column", overflow: "hidden" 
      }}
    >
      {/* Header */}
      <Box sx={{ p: "10px", borderBottom: "1px solid #e0e0e0",...rowSB }}>
     <Breadcrumbs
          separator={<NavigateNextOutlined fontSize="small" />}
          sx={{
        p: "0 10px",
        alignItems:"flex-end",
        ".MuiBreadcrumbs-separator": {
          fontSize: "0.75rem",
          color: globalColors.primary.normalText,
          margin: "10px",
        },
      }}
        >
          {iconText({
            key: `1`,
            // iconsx:"2px",
            // iconsx:!last&&{marginBottom:"4px"},
            text:  hierarchy
              ? `New Destination -> ${hierarchy.exam} • ${hierarchy.goal} • ${
                  hierarchy.section
                } • ${hierarchy.topic} ${
                  hierarchy.subtopic ? `• ${hierarchy.subtopic} •` : ""
                } `
              : "Questions",
            icon: "",
            sx: {
              cursor: "pointer",
              color: globalColors.primary.purple,
              // first ? globalColors.primary.purple :
            },
            size: "0.75rem",
            onClick: onClose,
            classname: "linkStyle-always",
          })}    
          
          {iconText({
                      key:`S`,
                      // iconsx:"2px",
                      // iconsx:!last&&{marginBottom:"4px"},
                      text: "Import Questions",
                      icon: "",
                      sx: {
                        cursor: "",
                        color:globalColors.primary.normalText,
                        // first ? globalColors.primary.purple :
                      },
                      size:"0.75rem",
                      onClick:()=>{},
                      classname: "",
                    })}
                   
        </Breadcrumbs>
        <CustomIconButton
                    onClick={onClose}
                    noHover={true}
                    
                    content={<SvgPreview svg={cross} />}
                  />
      </Box>
      <Box sx={{ flex: 8, display: "flex", overflow: "hidden" }}>
        <MockMangementsContainer
          onClose={() => setPasteDialogOpen(false)}
          hierarchy={hierarchy}
          onSubmit={() => {
            setPasteDialogOpen(true);
          }}
        />
      </Box>
      {pasteDialogOpen && (
        <DistributeQuestionsDialog
          open={pasteDialogOpen}
          
          setLoader={setLoader}
          onClose={() => setPasteDialogOpen(false)}
          hierarchy={hierarchy}
          onPaste={(assigned) => {
            setlastMock(copiedData)
           clearCopiedData()
            setTimeout(() => {
              dispatch(updateRefetch(true));
            }, 1);
            setPasteDialogOpen(false);
             setLoader(false);
            onSubmit([])
          }}
        />
      )}
    </Stack>
  );
}

export default ImportQuestionsFromMock;
